var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"snackbar"},[_c('div',{staticClass:"snackbar-text"},[_vm._t("default")],2),(_vm.action)?_c('div',{staticClass:"snackbar-action"},[_c('button',{on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.action))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }